export default "__VITE_ASSET__C1fwZ1YL__"